const isDev = import.meta.env.DEV
const devIP = import.meta.env.VITE_DEV_IP || 'localhost'
const backendPort = import.meta.env.VITE_BACKEND_PORT || 3000

let baseUrl, wsUrl

if (isDev) {
  baseUrl = `http://${devIP}:${backendPort}`
  wsUrl = `ws://${devIP}:${backendPort}`
} else {
  const baseDomain = window.location.hostname.replace(/^team([.-])/, 'admin$1')
  baseUrl = `${window.location.protocol}//${baseDomain}`
  wsUrl = `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${baseDomain}`
}

const appConfig = {
  apollo: {
    networkInterface: `${baseUrl}/graphql`,
    baseUrl
  },
  actionCable: {
    networkInterface: `${wsUrl}/cable`,
    baseUrl: wsUrl
  }
}

export default appConfig
